import React, { Fragment, useEffect } from 'react'
import { useIntl } from 'react-intl'

let instance = null

// Does not actually render anything visible.
// We need it to provide access to internationalization for classes
// which are not a React component
const CurrentLocale = () => {
  const intl = useIntl()

  useEffect(() => {
    if (!instance) instance = intl
  }, [])

  return false
}

export default CurrentLocale

export function formattedMessage(...args) {
  const message = instance.formatMessage(...args)

  if (!message) return ''
  if (typeof message === 'number') return ` (code ${message})`
  if (message.split('\n').length > 1) {
    return message.split('\n').map((item, key) => {
      return key > 0 ? (
        <Fragment key={key}>
          <br />
          {item}
        </Fragment>
      ) : (
        item
      )
    })
  } else {
    return message
  }
}

global.formattedMessage = formattedMessage
